import { INTERNAL_SERVICES_HOSTS, WEB_ROUTE_PATHS } from '@repo/routing';

export const HEADER_MENU_ITEMS = {
  home: {
    label: 'home',
    path: WEB_ROUTE_PATHS.home,
    base: WEB_ROUTE_PATHS.home(),
  },
  pricing: {
    label: 'pricing',
    path: WEB_ROUTE_PATHS.pricing,
    base: WEB_ROUTE_PATHS.pricing(),
  },
  about: {
    label: 'about',
    path: WEB_ROUTE_PATHS.about,
    base: WEB_ROUTE_PATHS.about(),
  },
  blog: {
    label: 'blog',
    path: WEB_ROUTE_PATHS.blog.base,
    base: WEB_ROUTE_PATHS.blog.base(),
  },
  contact: {
    label: 'contact',
    path: WEB_ROUTE_PATHS.contact,
    base: WEB_ROUTE_PATHS.contact(),
  },
};

export const FOOTER_MENU_ITEMS = [
  {
    title: 'company',
    items: {
      home: {
        label: 'home',
        path: WEB_ROUTE_PATHS.home,
        base: WEB_ROUTE_PATHS.home(),
      },
      about: {
        label: 'about',
        path: WEB_ROUTE_PATHS.about,
        base: WEB_ROUTE_PATHS.about(),
      },
      blog: {
        label: 'blog',
        path: WEB_ROUTE_PATHS.blog.base,
        base: WEB_ROUTE_PATHS.blog.base(),
      },
      contact: {
        label: 'contact',
        path: WEB_ROUTE_PATHS.contact,
        base: WEB_ROUTE_PATHS.contact(),
      },
    },
  },
  {
    title: 'product',
    items: {
      pricing: {
        label: 'pricing',
        path: WEB_ROUTE_PATHS.pricing,
        base: WEB_ROUTE_PATHS.pricing(),
      },
      catalog: {
        label: 'catalog',
        path: WEB_ROUTE_PATHS.catalog.base,
        base: WEB_ROUTE_PATHS.catalog.base(),
      },
      documentation: {
        label: 'documentation',
        path: () => INTERNAL_SERVICES_HOSTS.docs,
        base: INTERNAL_SERVICES_HOSTS.docs,
      },
    },
  },
  {
    title: 'resources',
    items: {
      privacy: {
        label: 'privacy',
        path: WEB_ROUTE_PATHS.legal.privacy,
        base: WEB_ROUTE_PATHS.legal.privacy(),
      },
      terms: {
        label: 'terms',
        path: WEB_ROUTE_PATHS.legal.terms,
        base: WEB_ROUTE_PATHS.legal.terms(),
      },
      cookie: {
        label: 'cookie',
        path: WEB_ROUTE_PATHS.legal.cookie,
        base: WEB_ROUTE_PATHS.legal.cookie(),
      },
      disclaimer: {
        label: 'disclaimer',
        path: WEB_ROUTE_PATHS.legal.disclaimer,
        base: WEB_ROUTE_PATHS.legal.disclaimer(),
      },
    },
  },
] as const;
